import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTableModule } from '../../modules/@datatable/datatables.module';
import { SharedModule } from '../../shared/shared.module';
import {AbleproDirectivesModule} from '../../_front/core/ablepro-directives.module';
import {PaginatorModule} from '../../shared/housing-modules/modules';
import {RealtyShowLogsComponent} from './realty-show-logs.component';
import {RealtyShowLogsResolve} from './realty-show-logs.resolve';
import {MaterialInputModule} from '../../modules/@material-input';
import {DictionaryModuleSourceResolver} from '../../resolvers/dictionary/dictionary-module-source.resolve';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DataTableModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialInputModule,
    SharedModule,
    AbleproDirectivesModule,
    PaginatorModule,
  ],
  declarations: [
    RealtyShowLogsComponent,
  ],
  exports: [
    RealtyShowLogsComponent,
  ],
  providers: [
    RealtyShowLogsResolve,
    DictionaryModuleSourceResolver,
  ]
})
export class RealtyShowLogsModule { }
